import { isType } from '@mtna/core-ts';
import { RelationalOperator } from '@mtna/data-core-ts';

/** Available numeric filters */
export type RdsNumericOperation = Extract<RelationalOperator, 'GT' | 'GE' | 'EQ' | 'NE' | 'LT' | 'LE'>;

export function invertNumericOperation(operation: RdsNumericOperation): RdsNumericOperation {
  switch (operation) {
    case 'GT':
      return 'LT';
    case 'GE':
      return 'LE';
    case 'EQ':
      return 'NE';
    case 'NE':
      return 'EQ';
    case 'LT':
      return 'GT';
    case 'LE':
      return 'GE';
  }
}

export class RdsNumericOperationOption {
  constructor(public label: string, public type: RdsNumericOperation) {}
}

export const RDS_NUMERIC_OPERATION_OPTIONS: ReadonlyArray<RdsNumericOperationOption> = Object.freeze([
  new RdsNumericOperationOption($localize`Greater than`, 'GT'),
  new RdsNumericOperationOption($localize`Greater than or Equal to`, 'GE'),
  new RdsNumericOperationOption($localize`Equal to`, 'EQ'),
  new RdsNumericOperationOption($localize`Not Equal to`, 'NE'),
  new RdsNumericOperationOption($localize`Less than`, 'LT'),
  new RdsNumericOperationOption($localize`Less than or Equal to`, 'LE'),
]);

/**
 * RDS Numeric Filter
 */
export class RdsNumericFilter {
  /**
   * Creates an instance of RdsNumericFilter
   * @param value number input
   * @param operation text of selected operation
   */
  constructor(public value: number | null, public operation: RdsNumericOperationOption | null) {}
}

export function instanceOfRdsNumericFilter(something: unknown): something is RdsNumericFilter {
  return (
    isType<RdsNumericFilter>(something, 'value', 'operation') &&
    (something.operation === null || RDS_NUMERIC_OPERATION_OPTIONS.map((o) => o.type).includes(something.operation.type))
  );
}
